import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=be1752c8&scoped=true&"
import script from "./TabButtons.vue?vue&type=script&lang=js&"
export * from "./TabButtons.vue?vue&type=script&lang=js&"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=be1752c8&scoped=true&lang=less&"
import style1 from "./TabButtons.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1752c8",
  null
  
)

export default component.exports